import IApiClient from "./ApiClient";
import { ReportResponse } from "models/StatisticsReport"

export interface IStatisticsService {
  getReport(id: string, start?: Date, end?: Date): Promise<ReportResponse | undefined>;
}

export default class StatisticsService implements IStatisticsService {
  apiBase: string;
  apiClient: IApiClient;

  constructor(apiClient: IApiClient) {
    this.apiBase = '/api/Statistics/';
    this.apiClient = apiClient;
  }

  async getReport(id: string, start?: Date, end?: Date | null): Promise<ReportResponse | undefined> {
    try {

      let url = `${this.apiBase}getreport/${id}`;
      const params = new URLSearchParams();

      if (start) {
        params.append('start', start.toISOString());
      }
      if (end) {
        params.append('end', end.toISOString());
      }


      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const response = await this.apiClient.get<ReportResponse>(url);
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }
}